const SIGNED_IN_HINT_COOKIE = "opus_signed_in";
const SIGNED_IN_HINT_MAX_AGE = 60 * 60 * 24 * 30;

const hintDomain = (): string | null => {
  const host = window.location.hostname;
  return host === "opus.so" || host.endsWith(".opus.so") ? "opus.so" : null;
};

const writeHint = (value: string, maxAge: number): void => {
  const domain = hintDomain();
  if (!domain) {
    return;
  }
  document.cookie = `${SIGNED_IN_HINT_COOKIE}=${value}; domain=${domain}; path=/; max-age=${maxAge}; secure; samesite=lax`;
};

export const setSignedInHint = (): void =>
  writeHint("1", SIGNED_IN_HINT_MAX_AGE);

export const clearSignedInHint = (): void => writeHint("", 0);
